import Vue from 'vue';

import Button from '@components/ui/button.vue';
import Count from '@components/ui/count.vue';
import ProductsGrid from '@components/products-grid/script';

let PageComponent = {
  name: 'products',
  data() {
    return {
      template: '<p>default temp</p>',
    };
  },
  components: {
    't-button': Button,
    't-count': Count,
    'products-grid-cmp': ProductsGrid,
  },
  methods: {
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let products = document.querySelector('#products');
    if (products) {
      products.remove();
    }

    let url = '/api/templates/products';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/products/index.js